module.exports = __webpack_public_path__ + "img/map_white.f630fb97.png";